import { OnboardingProcessStepNameType } from 'api/types/entity';

import {
  PersonalDataStep,
  CitizenshipStep,
  PepConnectionStep,
  RegistrationAddressStep,
  HeadPositionStep,
  TaxResidencyStep,
  IdentityDocumentStep,
} from './steps';
import { RoutePage } from './types';

export const pagesMap: Partial<
  Record<OnboardingProcessStepNameType, RoutePage['component']>
> = {
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadPersonalData]:
    PersonalDataStep,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadCitizenships]:
    CitizenshipStep,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadTaxResidencies]:
    TaxResidencyStep,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadAddresses]:
    RegistrationAddressStep,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadPep]:
    PepConnectionStep,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadPositionInCompany]:
    HeadPositionStep,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadIdentityDocument]:
    IdentityDocumentStep,
};
